import { Edit } from 'react-admin'

import CollectionForm, { getDefaultCollectionPrice } from './CollectionCodeForm'

const transform = data => ({
  ...data,
  price:
    data.price === undefined || data.price === null || data.price === ''
      ? getDefaultCollectionPrice(data.items)
      : data.price,
})

const CollectionEdit = props => {
  return (
    <Edit undoable={false} {...props} transform={transform}>
      <CollectionForm editing />
    </Edit>
  )
}

export default CollectionEdit
